module.exports = __webpack_public_path__ + "img/default-avatar.659975c2.jpg";